export const getAddressFromMeterInformation = address => {
  const name = address.street ?? ''
  const streetNumber = address.number ?? ''
  const city = address.townName ?? ''
  const zipcode = address.postalCode ?? ''
  const inseeCode = address.insee ?? ''

  if (name.length > 0 && city.length > 0 && zipcode.length > 0 && inseeCode.length > 0) {
    return {
      label: streetNumber + ' ' + name + ' ' + zipcode + ' ' + city,
      address: name,
      streetNumber,
      city,
      inseeCode,
      zipcode,
    }
  }
  return null
}
